import { render } from "./VisionFourCharts.vue?vue&type=template&id=bbb23ece"
import script from "./VisionFourCharts.vue?vue&type=script&lang=js"
export * from "./VisionFourCharts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__